import { css } from "@emotion/react";

import type { NodeSelectionCriteria } from "../../library";
import type { DesignerNode } from "../../types";
import { NodeTreeSlotActionsMenu } from "./NodeTreeSlotActionsMenu";

interface Props {
  parentNode: DesignerNode;
  name: string;
  descriptor: NodeSelectionCriteria;
}

export const NodeSlotsEntry = ({ parentNode, name, descriptor }: Props) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        // it's a slot lol
        border: 1px dotted grey;
      `}
    >
      <p>
        Slot <b>{name}</b>
      </p>
      <NodeTreeSlotActionsMenu slotId={{ name, parentId: parentNode.id }} slotDescriptor={descriptor} />
    </div>
  );
};
